import { gql } from 'apollo-boost';

export const deleteService2portfolioMutation = gql`
  mutation deleteService2portfolioMutation($portfolioId: Int!, $serviceId: Int!) {
    deleteService2portfolio(portfolioId: $portfolioId, serviceId: $serviceId) {
      success
    }
  }
`;
